export default __webpack_public_path__ + "static/media/eat.987f8368.svg";